import { DomainError } from '@dma/shared';

/**
 * Shared domain error for both Album and GalleryItem — kept singular
 * (rather than one class per entity) since both entities belong to the
 * same small aggregate and always fail for the same class of reason
 * (malformed content-file entry).
 */
export class InvalidGalleryContentError extends DomainError {
  constructor(reason: string) {
    super('INVALID_GALLERY_CONTENT', `Gallery content is invalid: ${reason}`);
    this.name = 'InvalidGalleryContentError';
    Object.setPrototypeOf(this, InvalidGalleryContentError.prototype);
  }
}
